module.exports = __webpack_public_path__ + "img/chouxianggainian.bf1297ae.png";